export default "__VITE_ASSET__C9iQgXjf__"